var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-title',{staticClass:"subtitle-page valentine",attrs:{"title":_vm.subtitle,"text-color":_vm.textColor}})}
var staticRenderFns = []

export { render, staticRenderFns }